<app-page-wrapper
  [title]="'Create Account'"
  [link]="'dashboard'"
>
  <div class="plan-title" *ngIf="plan.name && plan.monthly_price">
    <h3 class="color-white mt-0 mb-0">
      <svg class="mr-05" width="20" height="20">
        <use xlink:href="#crown-i"/>
      </svg>
      <span>{{ plan.name }}</span>
    </h3>
    <b class="color-accent">£{{ plan.monthly_price }}/m</b>
  </div>

  <div *ngIf="plan.id" class="form" [formGroup]="form">
    <div class="inputs-wrap">
      <div class="form-group form-group--icon-left">
        <svg width="24" height="24" class="form-group__icon">
          <use xlink:href="#person-i"/>
        </svg>
        <input formControlName="name" class="form-group__input" type="text" placeholder="Clinic Name">
        <span class="form-group__errors" *ngIf="fcName.touched && fcName.errors && fcName.errors.required">Name is required!</span>
      </div>

      <div class="form-group form-group--icon-left">
        <svg width="24" height="24" class="form-group__icon">
          <use xlink:href="#email-i"/>
        </svg>
        <input formControlName="email" class="form-group__input" type="email" placeholder="Email">
        <span class="form-group__errors" *ngIf="fcEmail.touched && fcEmail.errors && fcEmail.errors.required">Email is required!</span>
      </div>

      <div class="form-group form-group--icon-left form-group--icon-right">
        <svg width="24" height="24" class="form-group__icon">
          <use xlink:href="#lock-i"/>
        </svg>
        <input formControlName="pw"
               class="form-group__input"
               [type]="showPassword ? 'text' : 'password'"
               placeholder="Password">
        <app-pw-eye *ngIf="fcPw.value?.length"
                    [isVisible]="showPassword"
                    class="form-group__right-icon"
                    (click)="togglePasswordVisibility()"></app-pw-eye>
        <span class="form-group__errors" *ngIf="fcPw.touched && fcPw.errors && fcPw.errors.required">Password is required!</span>
        <span class="form-group__errors"
              *ngIf="fcPw.touched && fcPw.errors && fcPw.errors.minlength">Minimum length is {{ MIN_PW_LENGTH }}
          chars!</span>
      </div>
    </div>

    <button mat-flat-button class="btn btn--l btn--primary btn--block" (click)="onSubmit()" [disabled]="form.invalid">Create</button>
  </div>
</app-page-wrapper>
